import { clsx } from 'clsx'
import { type FC } from 'react'

import { productSearchAlgoliaAccessorGetPricingData } from '../../../model/productSearchAlgoliaAccessor/productSearchAlgoliaAccessorGetPricingData'
import { useProductSearchResultItemContext } from '../ProductSearchResultItemContext/productSearchResultItemContext'

interface FormattedUnitPriceProps {
  classNames?: string
}

export const ProductSearchResultItemPriceContainerFormattedUnitPrice: FC<
  FormattedUnitPriceProps
> = ({ classNames }) => {
  const { algoliaRecord } = useProductSearchResultItemContext()

  const { pricePerUnitFormatted } =
    productSearchAlgoliaAccessorGetPricingData(algoliaRecord)

  return pricePerUnitFormatted ? (
    <div
      className={clsx('text-dark-primary-strong', classNames)}
      data-qa-id="current-variant-price-per-unit"
    >
      {pricePerUnitFormatted}
    </div>
  ) : null
}
